import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function FrechiseCta() {
  const navigate = useNavigate();
  return (
    <section className="franchise-cta-section py-5 bg-primary text-white">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="display-5 fw-bold mb-4">
              Become a Sevasati Partner
            </h2>

            <p className="lead mb-4">
              Join our partner program and help local communities adopt smart
              society management solutions.
            </p>

            {/* Benefits */}
            <div
              className="benefits-list text-start mx-auto mb-5"
              style={{ maxWidth: "600px" }}
            >
              <div className="benefit-item mb-3 d-flex align-items-start">
                <FaCheckCircle className="me-2 mt-1" />
                <span>Low investment with scalable earning potential</span>
              </div>

              <div className="benefit-item mb-3 d-flex align-items-start">
                <FaCheckCircle className="me-2 mt-1" />
                <span>Structured training and continuous support</span>
              </div>

              <div className="benefit-item mb-3 d-flex align-items-start">
                <FaCheckCircle className="me-2 mt-1" />
                <span>Area-wise partnership opportunities</span>
              </div>

              <div className="benefit-item mb-3 d-flex align-items-start">
                <FaCheckCircle className="me-2 mt-1" />
                <span>Marketing assistance and lead support</span>
              </div>
            </div>

            {/* CTA Button */}
            <button className="btn btn-light btn-lg rounded-pill px-5" onClick={() => navigate("/contact-us")}>
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FrechiseCta;
